import React, {useState} from 'react';
import {useGetUserRelatedAttachmentsQuery} from 'src/redux/queries/attachment';
import {UserRelatedAttachmentsList} from './UserRelatedAttachmentsList';

const maxPageRows = 10;

export interface UserRelatedAttachmentsModuleProps {
  userId: number;
}

export const UserRelatedAttachmentsModule: React.FC<
  UserRelatedAttachmentsModuleProps
> = ({userId}) => {
  const [currentPage, setCurrentPage] = useState<number>(1);

  const {data, isFetching} = useGetUserRelatedAttachmentsQuery({
    userId,
    start: (currentPage - 1) * maxPageRows,
    length: maxPageRows,
  });

  const handlePageChange = (
    _event: React.ChangeEvent<unknown>,
    value: number
  ) => setCurrentPage(value);

  return (
    <UserRelatedAttachmentsList
      isLoading={isFetching}
      data={data?.data ?? []}
      currentPage={currentPage}
      totalRecords={data?.totalRecords ?? 0}
      recordsPerPage={maxPageRows}
      onPageChange={handlePageChange}
    />
  );
};
